import ListItem from "@material-ui/core/ListItem";
import {NavLink} from "react-router-dom";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import {Typography} from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import * as actionTypes from '../../../../../store/actionTypes'
import {useExpandableDrawerListItemStyles} from "./ExpandableDrawerListItemStyles";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {useCallback} from "react";
import {EXPAND_MOBILE_MENU} from "../../../../../shared/utils/constants/storage";

const ExpandableDrawerListItem = (props) => {
    const expand = useSelector((state) => state.authReducer.expandMobileMenu)
    const dispatch = useDispatch();

    const classes = useExpandableDrawerListItemStyles()

    const handleExpandMobileMenu = useCallback(() => {
        sessionStorage.setItem(EXPAND_MOBILE_MENU, String(!expand))
        dispatch({type: actionTypes.EXPAND_MOBILE_MENU, payload: !expand})
    }, [dispatch, expand])

    return (
        <>
            <ListItem button
                      onClick={handleExpandMobileMenu}
                      className={classes.root}>
                <NavLink exact
                         activeStyle={{backgroundColor: "#b14536"}}
                         to={props.to}
                         className={classes.navlink}>
                    <ListItemIcon className={classes.listItemIcon}>
                        {props.icon}
                    </ListItemIcon>
                    <Typography variant="button" className={classes.listItemText}>
                        {props.text}
                    </Typography>
                    {expand ?
                        <ExpandLess className={classes.expandIcon}/> :
                        <ExpandMore className={classes.expandIcon}/>}
                </NavLink>
            </ListItem>
            <Collapse className={classes.collapsableMenu} in={expand} timeout="auto" unmountOnExit>
                {props.children}
            </Collapse>
        </>
    )
}

ExpandableDrawerListItem.propTypes = {
    to: PropTypes.string.isRequired,
    icon: PropTypes.element.isRequired,
    text: PropTypes.string.isRequired,
    children: PropTypes.array.isRequired
}

export default ExpandableDrawerListItem
